import * as requestFromServer from './usersCrud';
import { usersSlice, callTypes } from './usersSlice';

const { actions } = usersSlice;

export const fetchUsers = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findUsers(queryParams)
    .then((response) => {
      console.log('usersAction: fetchUsers ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.usersFetched({ totalCount, entities }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find users";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchUser = (id) => (dispatch) => {
  if (!id) {
    return dispatch(actions.userFetched({ userForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getUserById(id)
    .then((response) => {
      console.log('usersAction: fetchUser ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { user } = { user: response.data.data };
          dispatch(actions.userFetched({ userForEdit: user }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find user";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteUser = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteUser(id)
    .then((response) => {
      console.log('usersAction: deleteUser ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.userDeleted({ id }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't delete user";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createUser = (userForCreation) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createUser(userForCreation)
    .then((response) => {
      console.log('usersAction: createUser ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { user } = { user: response.data.data };
          dispatch(actions.userCreated({ user }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't create user";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateUser = (user) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateUser(user)
    .then((response) => {
      console.log('usersAction: updateUser ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { user } = { user: response.data.data };
          dispatch(actions.userUpdated({ user }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update user";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateUserStatus = (id, status) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateUserStatus(id, status)
    .then((response) => {
      console.log('usersAction: updateUserStatus ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { user } = { user: response.data.data };
          dispatch(actions.userUpdated({ user }));
          //dispatch(actions.userStatusUpdated({ id, status }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update user status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateUsersStatus = (ids, status) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForUsers(ids, status)
    .then((response) => {
      console.log('usersAction: updateUsersStatus ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.usersStatusUpdated({ ids, status }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update users status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteUsers = (ids) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteUsers(ids)
    .then((response) => {
      console.log('usersAction: deleteUsers ...');
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.usersDeleted({ ids }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't delete users";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
